import { Menu, Phone, X } from 'lucide-react';
import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSiteContent } from '../content/ContentContext';

export default function Header() {
  const [open, setOpen] = useState(false);
  const {
    content: { navItems, site },
  } = useSiteContent();

  return (
    <header className="sticky top-0 z-50 border-b border-black/10 bg-white/95 backdrop-blur">
      <div className="bg-[#0d4f12] px-4 py-2 text-center text-sm font-medium text-white">
        {site.topBarText}
      </div>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3">
          <img src="/images/logo.jpg" alt={site.businessName} className="h-14 w-auto rounded-md object-contain" />
          <div className="hidden sm:block">
            <p className="text-lg font-extrabold tracking-tight text-[#0d4f12]">{site.shortBusinessName}</p>
            <p className="text-sm font-medium text-slate-600">{site.serviceArea}</p>
          </div>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `text-sm font-semibold transition ${isActive ? 'text-[#33b300]' : 'text-slate-700 hover:text-[#0d4f12]'}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href={site.phoneHref}
            className="inline-flex items-center gap-2 rounded-full bg-[#33b300] px-5 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-[#289000]"
          >
            <Phone size={18} /> {site.phoneDisplay}
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex rounded-md border border-slate-300 p-2 text-slate-700 lg:hidden"
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-black/10 bg-white lg:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 sm:px-6">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2 text-sm font-semibold ${isActive ? 'bg-[#eff9e8] text-[#0d4f12]' : 'text-slate-700'}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href={site.phoneHref}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-[#33b300] px-5 py-3 text-sm font-bold text-white"
            >
              <Phone size={18} /> {site.phoneDisplay}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
